var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-toolbar",
    {
      staticClass: "top-menubar",
      attrs: {
        app: "",
        "clipped-left": _vm.$vuetify.breakpoint.mdAndUp,
        fixed: "",
        color: "primary",
        dark: "",
      },
    },
    [
      _c(
        "v-toolbar-title",
        { staticClass: "ml-0" },
        [
          _vm.isLoggedIn && _vm.showMenuIcon && !_vm.jobIdToShowInHeader
            ? _c("v-toolbar-side-icon", {
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    return _vm.$emit("setNavDrawer")
                  },
                },
              })
            : _vm._e(),
          _vm.showWarning && _vm.jobId
            ? _c("JobWarnings", { attrs: { "job-id": _vm.jobId } })
            : _vm._e(),
          _vm.showJobAddress
            ? _c("span", { staticClass: "hidden-sm-and-down" }, [
                _vm._v(" " + _vm._s(_vm.jobAddress) + " "),
              ])
            : _vm.showDashBoardName !== ""
            ? _c("span", { staticClass: "hidden-sm-and-down" }, [
                !_vm.jobIdToShowInHeader
                  ? _c("span", [_vm._v(_vm._s(_vm.showDashBoardName))])
                  : _c("span", [
                      _vm._v("Job Id: " + _vm._s(_vm.jobIdToShowInHeader)),
                    ]),
              ])
            : _c("span", { staticClass: "hidden-sm-and-down" }, [
                _vm._v("SIMPLIFi"),
              ]),
        ],
        1
      ),
      _c("v-spacer"),
      _vm.isLoggedIn && !_vm.jobIdToShowInHeader
        ? _c("UniversalSearch", { attrs: { "parent-component": "App" } })
        : _vm._e(),
      _vm.isLoggedIn
        ? _c("Notification", {
            attrs: { "notification-snackbar": _vm.notificationSnackbar },
            on: {
              "update:notificationSnackbar": function ($event) {
                return _vm.$emit("update:notificationSnackbar", $event)
              },
            },
          })
        : _vm._e(),
      _vm.addSpace ? _c("div", { staticClass: "menu-spacer" }) : _vm._e(),
      _vm.isLoggedIn && _vm.isUserLoggedIn
        ? _c("TwilioClient", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.showLiveLocation,
                expression: "!showLiveLocation",
              },
            ],
            on: {
              showTwilioSnackbar: (msg, counter) =>
                _vm.$emit("showTwilioSnackbar", msg, counter),
              clearTwilioSnackbar: function ($event) {
                return _vm.$emit("clearTwilioSnackbar")
              },
              handleStatusUpdate: (isOffline) =>
                _vm.$emit("handleStatusUpdate", isOffline),
            },
          })
        : _vm._e(),
      _vm.isLoggedIn ? _c("AppSwitcher") : _vm._e(),
      _vm.isLoggedIn
        ? _c("UserMenu", {
            attrs: {
              "image-snackbar": _vm.imageSnackbar,
              "image-snackbar-text": _vm.imageSnackbarText,
            },
            on: {
              "update:imageSnackbar": function ($event) {
                return _vm.$emit("update:imageSnackbar", $event)
              },
              "update:imageSnackbarText": function ($event) {
                return _vm.$emit("update:imageSnackbarText", $event)
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }